<template>
  <div>
    <div class="DeliveryDetails">
      <div class="TabPanel">
        <span
          :class="[{'Selected': tab === 'request'}, 'Tab']"
          @click="tab = 'request'"
        >Request</span>
        <span
          :class="[{'Selected': tab === 'response'}, 'Tab']"
          @click="tab = 'response'"
        >Response</span>
      </div>
      <section
        v-if="tab === 'request'"
        class="Container"
      >
        {{ delivery.payload }}
      </section>
      <section
        v-else-if="tab === 'response'"
        class="Container"
      >
        {{ delivery.responseGivenByReceivingApplication }}
      </section>
      <div class="Button--container">
        <button
          class="Button Button--green"
          @click="$emit('deliveries:close')"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    delivery: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tab: 'request',
    };
  },
};
</script>
<style scoped lang="scss">
 .DeliveryDetails {
    border: 1px solid #E3E3E3;
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: 0 13px 29px 0 rgba(0,0,0,0.11);

    .TabPanel {
        border-bottom: 1px solid lightgray;
        padding: 10px 0 0 29px;
    }

    .Tab {
        padding: 10px 25px;
        border: 1px solid lightgray;
        display: inline-block;
        cursor: pointer;
        margin: 0px -2px;

        &.Selected {
            background:#F7F8F9;
        }
    }

    .Button--container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .Button--green {
        margin: 10px;
        float: right;
    }
  }
  .Container {
    white-space: pre-line;
  }
</style>
